import { useEffect, useRef, useState, useCallback } from 'react'

const API_URL = process.env.REACT_APP_BACKEND_URL
const HEARTBEAT_MS = 20000

export function useSinistrePresence(sinistreId, profile) {
  const [autres, setAutres] = useState([])
  const userId = profile?.id
  const userNom = profile ? `${profile.prenom || ''} ${profile.nom || ''}`.trim() || profile.email : ''

  useEffect(() => {
    if (!sinistreId || !userId) return
    let active = true
    const url = `${API_URL}/api/sinistres/${sinistreId}/presence`
    const beat = async () => {
      try {
        const res = await fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ user_id: userId, user_nom: userNom }) })
        if (res.ok && active) setAutres((await res.json()).autres || [])
      } catch { /* silencieux */ }
    }
    const quitter = () => { fetch(`${url}/${userId}`, { method: 'DELETE', keepalive: true }).catch(() => {}) }
    beat()
    const timer = setInterval(beat, HEARTBEAT_MS)
    window.addEventListener('pagehide', quitter)
    return () => { active = false; clearInterval(timer); window.removeEventListener('pagehide', quitter); quitter() }
  }, [sinistreId, userId, userNom])

  return autres
}

// Intercepte les PATCH /api/sinistres/{id} de la page pour injecter la version chargee (verrou optimiste).
export function useConflitEdition(sinistreId, profile, versionRef) {
  const [conflit, setConflit] = useState(null)
  const userNom = profile ? `${profile.prenom || ''} ${profile.nom || ''}`.trim() || profile.email : ''
  const userNomRef = useRef(userNom)
  userNomRef.current = userNom

  useEffect(() => {
    if (!sinistreId) return
    const target = `${API_URL}/api/sinistres/${sinistreId}`
    const original = window.fetch
    window.fetch = async (input, init = {}) => {
      const url = typeof input === 'string' ? input : input?.url
      const method = (init.method || 'GET').toUpperCase()
      if (url !== target || method !== 'PATCH' || typeof init.body !== 'string') return original(input, init)
      let body
      try { body = JSON.parse(init.body) } catch { return original(input, init) }
      if (versionRef.current) body._expected_updated_at = versionRef.current
      body._user_id = profile?.id
      body._user_nom = userNomRef.current
      const res = await original(input, { ...init, body: JSON.stringify(body) })
      if (res.status === 409) {
        const data = await res.clone().json().catch(() => ({}))
        if (data?.detail?.conflict) setConflit(data.detail)
      } else if (res.ok) {
        const data = await res.clone().json().catch(() => null)
        if (data?.sinistre?.updated_at) versionRef.current = data.sinistre.updated_at
      }
      return res
    }
    return () => { window.fetch = original }
  }, [sinistreId, profile?.id, versionRef])

  const fermer = useCallback(() => setConflit(null), [])
  return [conflit, fermer]
}
